import React from 'react';
import { ThemeLoader, StyleLoader } from '@sightworks/theme';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import FreeformProps from './props';

const FreeformBlock = ({ classes, body, useContrast }: FreeformProps, ref: React.Ref<HTMLDivElement>) => (
	<div
		className={clsx(classes.root, { [classes.contrast]: useContrast })}
		dangerouslySetInnerHTML={{ __html: body }}
		ref={ref}
	/>
);

const Styles = makeStyles(
	theme => ({
		root: {
			margin: 0,
			'& a': {
				textDecoration: 'none',
				transition: theme.transitions.create('color'),
				'&:hover': {
					textDecoration: 'underline',
				},
				'&.primary': {
					color: theme.palette.primary.light,
					'&:hover': {
						color: theme.palette.primary.dark,
					}
				},
				'&.secondary': {
					color: theme.palette.secondary.main,
					'&:hover': {
						color: theme.palette.secondary.dark,
					},
				},
			},
			'& > :first-child': { marginTop: 0 },
			'& > :last-child': { marginBottom: 0 },
			...theme.typography.body1,
			'& h1, & .h1': theme.typography.h1,
			'& h2, & .h2': theme.typography.h2,
			'& h3, & .h3': theme.typography.h3,
			'& h4, & .h4': theme.typography.h4,
			'& h5, & .h5': theme.typography.h5,
			'& h6, & .h6': theme.typography.h6,
			'& .body1': theme.typography.body1,
			'& .body2': theme.typography.body2,
			'& .caption': theme.typography.caption,
			'& .button': theme.typography.button,
			'& .subtitle1': theme.typography.subtitle1,
			'& .subtitle2': theme.typography.subtitle2,
			'& .overline': theme.typography.overline,
		},
		contrast: {
			color: theme.palette.primary.contrastText,
		},
	}),
	{ name: 'SWFreeform' }
);

export default ThemeLoader(StyleLoader(FreeformBlock, Styles));
